enum ErrorCodeEnum {
  VALIDATION = 10,
  FIELD_REQUIRED = 11,
  TOKEN_EXPIRED = 15,
  WEBHOOK_TEST_FAILED = 19,
  FORCE_REQUIRED = 20,
  PRECHECK_REQUIRED = 25,
  TWO_FA_REQUIRED = 30,
  TWO_FA_ERROR = 35,
  USER_LOGGED_IN = 40,
}

export { ErrorCodeEnum };
